module.exports = __webpack_public_path__ + "media/recipes/93-25f57c35.png";